<!-- <ng-sidebar-container (onBackdropClicked)="_onBackdropClicked()">
<ng-sidebar
  *ngIf="isNotLoginPage$ | async"
  [opened]="menuState$ | async"
  [mode]="'over'"
  [closeOnClickOutside]="true"
  [closeOnClickBackdrop]="true"
  (onClosed)="_onClosed()"
  (onOpened)="_onOpened()"
  [showBackdrop]="true"
  class="kn-br-sidebar"
  >
  <cx-page-slot position="TopHeaderSlot"></cx-page-slot>
</ng-sidebar>
<div ng-sidebar-content>
  <kn-br-outlet></kn-br-outlet>
</div>
</ng-sidebar-container> -->
@if (pdpLoading$ | async) {
  <div class="kn-br-global-loader-overlay">
    <cx-spinner class="overlay"></cx-spinner>
  </div>
}

<mat-sidenav-container class="example-container">
  @if (isNotLoginPage$ | async) {
    <mat-sidenav [opened]="menuState$ | async" [mode]="'over'" (closed)="_onClosed()"
      (opened)="_onOpened()" class="kn-br-sidebar">
      <cx-page-slot position="TopHeaderSlot"></cx-page-slot>
    </mat-sidenav>
  }

  <mat-sidenav-content>
    <kn-br-outlet></kn-br-outlet>
    <cx-storefront [ngClass]="{ 'asm-storefront': isLoggedInASM }"></cx-storefront>
  </mat-sidenav-content>
</mat-sidenav-container>

@if (isHomePage$ | async) {
  <a
    class="kn-br-feedback-survey-tab"
    [href]="feedbackSurveyUrl"
    target="_blank"
    rel="noopener noreferrer"
  >{{ 'label.feedbackSurvey' | cxTranslate }}</a>
}
